/**
 * @generated SignedSource<<f917f75378abc8cf28ed5c06bf558e14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WalletPaymentMethod_viewer$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"WalletCreditCardOption_viewer">;
  readonly " $fragmentType": "WalletPaymentMethod_viewer";
};
export type WalletPaymentMethod_viewer$key = {
  readonly " $data"?: WalletPaymentMethod_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"WalletPaymentMethod_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WalletPaymentMethod_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WalletCreditCardOption_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "34bda87e3c1c0093ea959eefd48bf234";

export default node;
